<category-component>
</category-component>
<div class="fixed-header-height">
    <hero-slider></hero-slider>
</div>
<app-sub-banner></app-sub-banner>
<app-recommend-products-slider></app-recommend-products-slider>

<app-brands [topBrandsListing]="topBrandsListing" [brandsListing]="brandsListing"
    [headerBrandsAlphabet]="headerBrandsAlphabet" *ngIf="topBrandsListing.length"></app-brands>
<offers-slider></offers-slider>
<product-listing-slider></product-listing-slider>



<div class="grey-bg">
    <testimonial-slider></testimonial-slider>
</div>
<download-app></download-app>